import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import TouchableElement from '@components/common/touchableElement';
import { SimpleOnPress } from '@interfaces/base';

interface DashboardListErrorProps extends WithColor, SimpleOnPress {
  message?: string | null;
  testID?: string;
  retryTestID?: string;
}

const DashboardListError: FC<DashboardListErrorProps> = ({ C, onPress, message, testID, retryTestID }) => (
  <View
    testID={testID}
    style={{ paddingVertical: scale(48), alignItems: 'center', justifyContent: 'center', gap: scale(12) }}
  >
    <Text style={[font['Subhead 2'], { color: C('System/Light/Red') }]}>{message ?? i18n.t('Error')}</Text>
    <TouchableElement testID={retryTestID} onPress={onPress}>
      {() => (
        <View
          style={{
            paddingVertical: scale(8),
            paddingHorizontal: scale(16),
            borderRadius: scale(8),
            backgroundColor: C('Background/Light/Tertiary'),
          }}
        >
          <Text style={[font['Button 2'], { color: C('System/Light/Blue') }]}>{i18n.t('Retry')}</Text>
        </View>
      )}
    </TouchableElement>
  </View>
);

export default ColorWrapper(DashboardListError);
